export function getStepAnimation (element, settings, withFade = false) {
    const animation = {
        y: 0,
        x: 0
    }
    if (withFade) {
        animation.opacity = 0
    }


    //Set the position properties based on the startposition
    if( settings.start_position ){
        // set y position
        if( settings.start_position.indexOf("top") > -1 ){
            animation.y =  "-="+settings.startoffset+"em";
        }else if( settings.start_position.indexOf("bottom") > -1 ){
            animation.y = "+="+settings.startoffset+"em";
        }
        // set x position
        if( settings.start_position.indexOf("left") > -1 ){
            animation.x = "-="+settings.startoffset+"em";
        }else if( settings.start_position.indexOf("right") > -1 ){
            animation.x = "+="+settings.startoffset+"em";
        }
    }
    return animation;
}
